import GATSBY_COMPILED_MDX from "/opt/build/repo/pages/npm-dependencies/index.md";
import React, {useEffect, useRef, useState} from 'react';
import Helmet from 'react-helmet';
import {Link, graphql} from 'gatsby';
import get from 'lodash/get';
import Layout from '../components/layout';
function IconChevronRight(props) {
  return React.createElement("svg", Object.assign({
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em"
  }, props), React.createElement("path", {
    d: "M9 18l6-6-6-6"
  }));
}
export function SidbarBox(props) {
  return React.createElement("div", {
    className: "rounded-lg mb-5 w-full hidden lg:block overflow-auto",
    style: {
      minHeight: '100px'
    }
  }, React.createElement("h3", {
    className: "text-lg m-0 mb-1 p-0"
  }, props.title), props.children);
}
function useCurPos(tabOfContents) {
  const [current, setCurrent] = useState('');
  const observer = useRef();
  useEffect(() => {
    const handleObserver = entries => {
      entries.filter(entry => entry?.isIntersecting).reverse().forEach(entry => setCurrent(entry.target.id));
    };
    observer.current = new IntersectionObserver(handleObserver, {
      rootMargin: '0% 0% -65% 0px'
    });
    if (!tabOfContents) return;
    tabOfContents?.map(urlAndtitle => document.querySelector(urlAndtitle.url)).filter(Boolean).forEach(element => observer.current.observe(element));
    return () => observer.current?.disconnect();
  }, []);
  return current ? '#' + current : '';
}
const BlogPostTemplate = props => {
  const post = props.data.mdx;
  const {tableOfContents} = post;
  const activeTableOfContentsItem = useCurPos(tableOfContents.items);
  const siteTitle = get(props, `data.config.frontmatter.title`);
  const siteDescription = post.excerpt;
  const {previous, next} = props.pageContext;
  const moreLinks = [];
  if (previous) {
    moreLinks.push(previous);
  }
  if (next) {
    moreLinks.push(next);
  }
  return React.createElement(Layout, {
    location: props.location,
    config: props.data.config
  }, React.createElement(Helmet, {
    htmlAttributes: {
      lang: props.pageContext.language
    },
    meta: [{
      name: 'description',
      content: siteDescription
    }],
    title: `${post.frontmatter.title} | ${siteTitle}`
  }), React.createElement("div", {
    className: "columns__container"
  }, React.createElement("div", {
    className: "columns__left "
  }, React.createElement("div", null, React.createElement("div", {
    className: "prose contentbox mx-auto"
  }, React.createElement("h2", {
    className: "text-xl mainheader mb-0  "
  }, post.frontmatter.title), React.createElement("p", {
    className: "text-gray-900 no-underline text-xs m-0 text-left font-bold text-slate-700"
  }, "Last updated on ", post.frontmatter.date)), React.createElement("div", {
    className: "prose contentbox"
  }, props.children))), React.createElement("div", {
    className: "columns__right "
  }, React.createElement("div", {
    className: "columns__sidebar"
  }, tableOfContents.items?.length >= 3 && React.createElement(SidbarBox, {
    title: 'Quick navigation'
  }, React.createElement("ul", {
    className: "text-sm"
  }, tableOfContents.items.map(i => React.createElement("li", {
    key: i.url,
    className: ""
  }, React.createElement("a", {
    href: i.url,
    key: i.url,
    className: 'border-l-2 pl-2 py-1 duration-100 ease-in-out transition-colors hover:text-blue-600 flex items-center hover:no-underline hover:bg-gray-50 hover:shadow font-normal bg-white ' + (activeTableOfContentsItem === i.url ? 'text-blue-700 border-blue-700 ' : 'text-slate-700')
  }, i.title))))), React.createElement("div", {
    id: "portal-dest"
  })))));
  return React.createElement(Layout, {
    location: props.location,
    config: props.data.config
  }, React.createElement(Helmet, {
    htmlAttributes: {
      lang: props.pageContext.language
    },
    meta: [{
      name: 'description',
      content: siteDescription
    }],
    title: `${post.frontmatter.title} | ${siteTitle}`
  }), React.createElement("div", {
    className: "w-full mx-auto format format-sm sm:format-base\n         "
  }, React.createElement("hr", {
    className: "my-6"
  }), React.createElement("div", {
    className: "contentbox"
  }, props.children)));
};
BlogPostTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPostTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    config: mdx {
      frontmatter {
        title
        slug
        language
        tags
      }
    }
    mdx(id: { eq: $id }) {
      id
      excerpt
      tableOfContents
      frontmatter {
        title
        date(formatString: "MMMM YYYY")
        tags
      }
    }

    previous: mdx(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: mdx(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`;
